<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="card-title">
              <div class="d-flex align-items-center justify-content-between">
                <div class="title-report d-flex align-items-center">
                  <div class="avatar-md mr-4">
                    <span
                      class="avatar-title rounded-circle bg-light text-danger font-size-16"
                    >
                      <img
                        v-if="detail"
                        :src="
                          require('@/assets/images/malware-icon/' +
                            detail.malware_logo)
                        "
                        alt
                        height="50"
                      />
                    </span>
                  </div>
                  <h2>{{ detail.title }}</h2>
                </div>
                <div
                  class="action-button d-inline-block"
                  v-if="!loading.detail"
                >
                  <b-button
                    v-if="detail.status_report != 0"
                    variant="primary"
                    class="btn mr-2"
                    @click="downloadReport()"
                  >
                    <i class="bx bxs-download font-size-16 align-middle"></i>
                  </b-button>
                  <router-link
                    :to="{
                      path: '/malware/create-report',
                      query: { id: getId(detail.id_report) },
                    }"
                    v-if="
                      detail.status_report == 0 || detail.status_report == 1
                    "
                  >
                    <b-button
                      variant="primary"
                      class="btn mr-2"
                      v-if="
                        role !== 'verif' && detail.report_by.id_user == id_user
                      "
                    >
                      <i class="bx bxs-edit font-size-16 align-middle mr-1"></i>
                      <span class="d-xl-inline d-lg-none d-md-none">Edit</span>
                    </b-button>
                  </router-link>
                  <b-button
                    variant="outline-danger"
                    class="btn mr-2"
                    v-if="
                      detail.status_report == '0' &&
                      detail.report_by.id_user == id_user
                    "
                    @click="confirmRemoveReport"
                  >
                    <i class="bx bx-trash font-size-16 align-middle mr-1"></i>
                    <span class="d-xl-inline d-lg-none d-md-none">Remove</span>
                  </b-button>
                  <b-button
                    v-if="detail.length != 0 && detail.status_report != 0"
                    variant="primary"
                    class="btn mr-2"
                    @click="openShareModal"
                    :disabled="loading.sharereport"
                  >
                    <i
                      class="bx bxs-share-alt font-size-16 align-middle mr-1"
                    ></i>
                    <span
                      class="d-xl-inline d-lg-none d-md-none"
                      v-if="loading.sharereport"
                      >{{ $t("button.sharing") }}</span
                    >
                    <span
                      class="d-xl-inline d-lg-none d-md-none"
                      v-if="!loading.sharereport"
                      >{{ $t("button.share") }}</span
                    >
                  </b-button>
                  <b-button
                    variant="primary"
                    class="btn float-right"
                    @click="openValidationModal"
                    v-if="
                      role == 'verf' &&
                      detail.status_report == 1 &&
                      detail.status_report != 0
                    "
                  >
                    <i
                      class="bx bxs-badge-check font-size-16 align-middle mr-1"
                    ></i>
                    <span
                      v-if="detail.status_report == 1"
                      class="d-xl-inline d-lg-none d-md-none"
                    >
                      <span v-if="!loading.validation">{{
                        $t("malware.give-validation")
                      }}</span>
                      <span v-if="loading.validation">{{
                        $t("button.validating")
                      }}</span>
                    </span>
                    <!-- <span
                      v-if="
                        detail.status_report != 1 && detail.status_report != 0
                      "
                      class="d-xl-inline d-lg-none d-md-none"
                    >
                      {{ $t("malware.edit-validation") }}
                    </span> -->
                  </b-button>
                </div>
              </div>
            </div>
            <hr />
            <div class="mt-4">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <h5>{{ $t("malware.report-information") }}</h5>
                      <div class="border rounded">
                        <div class="row py-3">
                          <div class="col-lg-6 border-right">
                            <div class="table-responsive">
                              <table class="table table-borderless mb-0">
                                <tbody>
                                  <tr>
                                    <th width="20%" class="py-2">
                                      {{ $t("malware.title") }}
                                    </th>
                                    <td class="py-2">{{ detail.title }}</td>
                                  </tr>
                                  <tr>
                                    <th width="20%" class="py-2">
                                      {{ $t("malware.description") }}
                                    </th>
                                    <td class="text-justify py-2">
                                      <readmore
                                        :text="detail.description"
                                        :maxChars="200"
                                      ></readmore>
                                      <!-- {{ detail.description }} -->
                                    </td>
                                  </tr>
                                  <tr>
                                    <th width="20%" class="py-2">Status</th>
                                    <td class="py-2">
                                      <span
                                        v-if="detail.status_report == '3'"
                                        class="badge badge-success font-size-12 px-3 py-1"
                                      >
                                        {{ $t("malware.valid") }}</span
                                      >
                                      <span
                                        v-if="detail.status_report == '2'"
                                        class="badge badge-danger font-size-12 px-3 py-1"
                                        >{{ $t("malware.not-valid") }}</span
                                      >
                                      <span
                                        v-if="detail.status_report == '1'"
                                        class="badge badge-info font-size-12 px-3 py-1"
                                        >{{ $t("malware.pending") }}</span
                                      >
                                      <span
                                        v-if="detail.status_report == '0'"
                                        class="badge badge-warning font-size-12 px-3 py-1"
                                        >{{ $t("malware.draft") }}</span
                                      >
                                    </td>
                                  </tr>
                                  <tr>
                                    <th width="20%" class="py-2">
                                      {{ $t("table.created_at") }}
                                    </th>
                                    <td class="py-2">
                                      {{ detail.created_at }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="col-lg-3 text-center">
                            <div class="">
                              <i class="bx bx-message-alt-add mr-1"></i>
                              <span class="font-weight-bold">{{
                                $t("malware.reported-by")
                              }}</span>
                            </div>
                            <router-link
                              class="text-dark"
                              :to="{
                                path: '/malware/user/detail',
                                query: {
                                  id: getId(
                                    detail.report_by
                                      ? detail.report_by.id_user
                                      : ''
                                  ),
                                },
                              }"
                            >
                              <div class="mx-auto">
                                <div class="avatar-lg mx-auto my-3">
                                  <img
                                    :src="urlImage + detail.report_by.avatar"
                                    class="img-thumbnail rounded-circle"
                                    alt="avatar"
                                    v-if="detail && detail.report_by.avatar"
                                  />
                                  <img
                                    src="@/assets/images/users/avatar-10.jpg"
                                    class="img-thumbnail rounded-circle"
                                    alt="avatar"
                                    v-else
                                  />
                                </div>
                                <p class="p-0 m-0">
                                  {{
                                    detail.report_by
                                      ? detail.report_by.name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </router-link>
                          </div>
                          <div class="col-lg-3 text-center">
                            <div class="">
                              <i class="bx bx-check-circle mr-1"></i>
                              <span class="font-weight-bold">{{
                                $t("malware.verified-by")
                              }}</span>
                            </div>
                            <router-link
                              class="text-dark"
                              :to="{
                                path: '/malware/user/detail',
                                query: {
                                  id: getId(
                                    detail.verify_by
                                      ? detail.verify_by.id_user
                                      : ''
                                  ),
                                },
                              }"
                              v-if="
                                detail.status_report !== '1' &&
                                detail.status_report !== '0'
                              "
                            >
                              <div class="mx-auto">
                                <div class="avatar-lg mx-auto my-3">
                                  <img
                                    :src="urlImage + detail.verify_by.avatar"
                                    alt
                                    class="img-thumbnail rounded-circle"
                                    v-if="detail && detail.verify_by.avatar"
                                  />
                                  <img
                                    src="@/assets/images/users/avatar-10.jpg"
                                    class="img-thumbnail rounded-circle"
                                    alt="avatar"
                                    v-else
                                  />
                                </div>
                                <p class="p-0 m-0">
                                  {{
                                    detail.verify_by
                                      ? detail.verify_by.name
                                      : ""
                                  }}
                                </p>
                              </div>
                            </router-link>
                            <div class="mx-auto" v-else>
                              <div class="avatar-lg mx-auto my-3"></div>
                              <p class="p-0 m-0">-</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12 mt-5">
                      <h5>{{ $t("malware.malware-details") }}</h5>
                      <b-tabs justified content-class="py-3 text-muted">
                        <b-tab
                          v-for="(mw, mwid) in malware"
                          :key="mwid"
                          :active="mwid == 0 ? true : false"
                          v-if="mw != null"
                        >
                          <template v-slot:title>
                            <span class="d-inline-block d-sm-none">
                              <i class="bx bx-detail"></i>
                            </span>
                            <span
                              class="d-none d-sm-inline-block mx-5 my-2"
                              v-if="mw.sandbox_source == 0"
                              >Other Sandbox</span
                            >
                            <span
                              class="d-none d-sm-inline-block mx-5 my-2"
                              v-if="mw.sandbox_source == 1"
                              >Checkpoint Sandbox</span
                            >
                            <span
                              class="d-none d-sm-inline-block mx-5 my-2"
                              v-if="mw.sandbox_source == 2"
                              >Ahnlab Sandbox</span
                            >
                          </template>
                          <div class="row">
                            <div class="col-lg-8">
                              <div class="border rounded h-100">
                                <div
                                  class="rounded d-flex justify-content-between align-items-center px-2 py-2 border-bottom mb-2"
                                  :class="theme == 'dark' ? '' : 'bg-light '"
                                >
                                  <span class="font-weight-bold">
                                    {{ $t("malware.basic-properties") }}
                                  </span>
                                  <div class="">
                                    <b-button
                                      size="sm"
                                      :variant="
                                        theme == 'dark'
                                          ? 'transparent'
                                          : 'light'
                                      "
                                      class="rounded"
                                      v-b-toggle="'basic-prop'"
                                    >
                                      <i
                                        class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                                      ></i>
                                    </b-button>
                                  </div>
                                </div>
                                <b-collapse id="basic-prop" class="mt-1">
                                  <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                      <tbody>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.file-name") }}
                                          </td>
                                          <td class="font-weight-bold">
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.filename }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.file_name }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source.file_name
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.threat-name") }}
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.threat_name }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{
                                                mw.malware.av.malware_info
                                                  .signature_name
                                              }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source
                                                  .detect_name
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.classification") }}
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.threat_name }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{
                                                mw.malware.av.malware_info
                                                  .signature_name
                                              }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source
                                                  .detect_name
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.severity") }}
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.threat_name }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.te.severity }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source.severity
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.file-type") }}
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.file_type }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.file_type }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source.file_type
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.file-size") }}
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.file_type }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{
                                                formatByte(
                                                  info_cp.length != 0 &&
                                                    info_cp.tech_detail
                                                    ? info_cp.tech_detail
                                                        .file_size
                                                    : "-"
                                                )
                                              }}
                                              (
                                              {{
                                                info_cp.length != 0 &&
                                                info_cp.tech_detail
                                                  ? info_cp.tech_detail
                                                      .file_size
                                                  : "-"
                                              }}
                                              Byte )
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                formatByte(
                                                  mw.malware[0]._source
                                                    .file_size
                                                )
                                              }}
                                              (
                                              {{
                                                mw.malware[0]._source.file_size
                                              }}
                                              Byte )
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">Tags</td>
                                          <td>
                                            <span
                                              v-for="tg in tags"
                                              :key="tg"
                                              class="badge badge-pill badge-primary py-2 px-3 mr-2"
                                              >{{ tg }}</span
                                            >
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </b-collapse>
                                <div
                                  class="d-flex justify-content-between align-items-center px-2 py-2 border-bottom mb-2 rounded"
                                  :class="theme == 'dark' ? '' : 'bg-light '"
                                >
                                  <span class="font-weight-bold">
                                    {{ $t("malware.information-on-execution") }}
                                  </span>
                                  <div class="">
                                    <b-button
                                      size="sm"
                                      :variant="
                                        theme == 'dark'
                                          ? 'transparent'
                                          : 'light'
                                      "
                                      class="rounded"
                                      v-b-toggle="'info-exe'"
                                    >
                                      <i
                                        class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                                      ></i>
                                    </b-button>
                                  </div>
                                </div>
                                <b-collapse id="info-exe" class="mt-1">
                                  <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                      <tbody>
                                        <tr>
                                          <td
                                            width="20%"
                                            class="font-weight-bold"
                                          >
                                            Start Execution
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.index_time }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{
                                                formatDetectTime(
                                                  mw.malware.detect_time
                                                )
                                              }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source
                                                  .detect_time
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            Finish Execution
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.finish_time }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.analysis_time }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{
                                                mw.malware[0]._source
                                                  .analysis_time
                                              }}
                                            </span>
                                          </td>
                                        </tr>
                                        <!-- <tr>
                                          <td class="font-weight-bold">
                                            {{ $t("malware.last-analysis") }}
                                          </td>
                                          <td>2020-03-29 20:47:49</td>
                                        </tr> -->
                                      </tbody>
                                    </table>
                                  </div>
                                </b-collapse>
                                <div
                                  class="d-flex justify-content-between align-items-center px-2 py-2 border-bottom mb-2 rounded"
                                  :class="theme == 'dark' ? '' : 'bg-light '"
                                >
                                  <span class="font-weight-bold">
                                    {{ $t("malware.hash-list") }}
                                  </span>
                                  <div class="">
                                    <b-button
                                      size="sm"
                                      :variant="
                                        theme == 'dark'
                                          ? 'transparent'
                                          : 'light'
                                      "
                                      class="rounded"
                                      v-b-toggle="'info-name'"
                                    >
                                      <i
                                        class="bx bx-chevron-down bx-sm font-size-16 align-middle"
                                      ></i>
                                    </b-button>
                                  </div>
                                </div>
                                <b-collapse id="info-name" class="mt-1">
                                  <div class="table-responsive">
                                    <table class="table table-borderless mb-0">
                                      <tbody>
                                        <tr>
                                          <td
                                            width="20%"
                                            class="font-weight-bold"
                                          >
                                            MD5
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.md5 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.md5 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              {{ mw.malware[0]._source.md5sum }}
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            SHA-1
                                          </td>
                                          <td>
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.sha1 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.sha1 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              --
                                            </span>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td class="font-weight-bold">
                                            SHA-256
                                          </td>
                                          <td>
                                            {{
                                              malware[0]
                                                ? malware[0].sha256
                                                : ""
                                            }}
                                            <span v-if="mw.sandbox_source == 0">
                                              {{ mw.sha256 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 1">
                                              {{ mw.malware.sha256 }}
                                            </span>
                                            <span v-if="mw.sandbox_source == 2">
                                              --
                                            </span>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </b-collapse>
                              </div>
                            </div>
                            <div class="col-lg-4 text-center">
                              <div class="border rounded pt-3">
                                <label for="score">{{
                                  $t("malware.score-risk-severity")
                                }}</label>
                                <apexchart
                                  v-if="detail.length != 0"
                                  class="apex-charts"
                                  type="radialBar"
                                  height="300"
                                  :options="gaugeOptions"
                                  :series="[detail ? detail.risk_score : 0]"
                                ></apexchart>
                              </div>
                            </div>
                          </div>
                        </b-tab>
                      </b-tabs>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-12">
        <div class="card px-3 py-2">
          <div class="card-title d-flex justify-content-between">
            <span>{{ $t("malware.comments") }}</span>
            <b-button
              variant="primary"
              size="sm"
              class="btn"
              title="Refresh"
              @click="listComment"
            >
              <i
                :class="loading.listcomment ? 'bx-spin' : ''"
                class="bx bx-revision font-size-16 align-middle"
              ></i>
            </b-button>
          </div>
          <div class="card-body">
            <div class="comment-list">
              <div
                class="media pt-2 pb-3 border-bottom"
                v-for="(cm, idx) in comments"
                :key="idx"
              >
                <img
                  :src="urlImage + cm.user.avatar"
                  class="avatar-xs mr-3 rounded-circle"
                  v-if="cm.user.avatar"
                  alt="ava"
                />
                <img
                  src="@/assets/images/users/avatar-10.jpg"
                  class="avatar-xs mr-3 rounded-circle"
                  alt="ava"
                  v-else
                />
                <div class="media-body">
                  <span class="text-muted mt-0 font-size-12 p-0 m-0">
                    {{ cm.user.name }}
                    {{ cm.user.id_user == id_user ? "(Me)" : "" }}
                  </span>
                  <p
                    class="font-size-16 p-0 m-0"
                    :class="theme == 'dark' ? 'text-white' : ''"
                  >
                    {{ cm.comment }}
                  </p>
                  <ul class="list-inline text-muted float-sm-right m-0">
                    <li
                      class="list-inline-item d-flex align-items-center p-0 m-0 font-size-10 text-muted font-size-12"
                    >
                      <i
                        class="bx bx-time-five bx-xs text-muted mr-1 text-muted"
                      ></i>
                      <i> {{ commentTime(cm.created_at) }} </i>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="comment-form mt-4">
              <label class="">{{ $t("malware.write-comments") }}</label>
              <textarea
                v-model="form.comment"
                class="form-control"
                name="textarea"
                rows="5"
              ></textarea>
              <b-button
                variant="primary"
                class="mt-2 float-right"
                @click="sendComment"
                :disabled="loading.sendcomment"
              >
                <span v-if="!loading.sendcomment">{{
                  $t("malware.send")
                }}</span>
                <span v-if="loading.sendcomment">{{
                  $t("malware.sending")
                }}</span>
                <i
                  :class="
                    loading.sendcomment ? 'bx bx-loader bx-spin' : 'bx bxs-send'
                  "
                  class="font-size-16 align-middle ml-2"
                ></i>
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="modal-validation"
        centered
        :title="$t('modal.title.validation')"
        title-class="font-18"
        hide-footer
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom01">{{
                $t("malware.status-report")
              }}</label>
              <select
                class="form-control"
                :class="{
                  'is-invalid':
                    submitted && $v.form.validation.status_report.$error,
                }"
                v-model="form.validation.status_report"
              >
                <option value="">{{ $t("malware.select") }}</option>
                <option value="valid">{{ $t("malware.valid") }}</option>
                <option value="not_valid">{{ $t("malware.not-valid") }}</option>
              </select>
              <div
                v-if="submitted && $v.form.validation.status_report.$error"
                class="invalid-feedback"
              >
                <span v-if="!$v.form.validation.status_report.required"
                  >This value is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom10">{{ $t("malware.note") }} </label>
              <textarea
                v-model="form.validation.verif_note"
                class="form-control"
                name="textarea"
                rows="5"
              ></textarea>
            </div>
          </div>
          <div class="col-md-12">
            <div class="text-right">
              <b-button
                class="mt-3 mr-1"
                @click="$bvModal.hide('modal-edit' + row.item.id_user)"
                variant="danger"
                >{{ $t("button.cancel") }}</b-button
              >
              <b-button
                class="mt-3 mr-1"
                :disabled="loading.validation"
                @click="giveValidation"
                variant="success"
              >
                <span v-if="loading.validation">
                  {{ $t("button.validating") }}
                </span>
                <span v-if="!loading.validation">
                  {{ $t("button.validation") }}
                </span>
              </b-button>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
        id="modal-share"
        centered
        :title="$t('modal.title.share')"
        title-class="font-18"
        :ok-title="
          loading.sharereport ? $t('button.sharing') : $t('button.share')
        "
        :ok-disabled="loading.sharereport"
        hide-footer
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom01">Email</label>
              <b-form-tags
                input-id="tags-separators"
                v-model="form.share.emails"
                placeholder="Add email to share"
                remove-on-delete
                :class="{
                  'is-invalid': shared && form.share.emails.length == 0,
                }"
              />
              <div
                v-if="form.share.emails.length == 0"
                class="invalid-feedback"
              >
                <span v-if="form.share.emails.length == 0"
                  >This value is required.</span
                >
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group">
              <label for="validationCustom10">Message </label>
              <textarea
                v-model="form.share.message"
                class="form-control"
                name="textarea"
                rows="5"
              ></textarea>
            </div>
          </div>
            <div class="col-md-12">
              <div class="text-right">
                <b-button
                  class="mt-3 mr-1"
                  @click="$bvModal.hide('modal-share')"
                  variant="danger"
                  >{{ $t("button.cancel") }}</b-button
                >
                <b-button
                  class="mt-3 mr-1"
                  @click="sendShareReport"
                  variant="primary"
                  ><span v-if="loading.sharereport">{{ $t('button.sharing')}}</span>
                  <span v-else>{{ $t('button.share') }}</span></b-button
                >
              </div>
            </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
// import ReadMore from "@/components/widgets/readmore";
import appConfig from "@/app.config";
import vue2Dropzone from "vue2-dropzone";
import { Buffer } from "buffer";
import { userService } from "@/helpers/authservice/user.service";
import ReportService from "@/helpers/report.service";
import CommentService from "@/helpers/comment.service";
import MalwareServices from "@/helpers/malware.service";
import Helpers from "@/helpers/auxiliary.function";
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import Vue from "vue";
import Swal from "sweetalert2";
import Readmore from "../../../components/widgets/readmore.vue";

/**
 * Projects-grid component
 */
export default {
  page: {
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    vueDropzone: vue2Dropzone,
    Layout,
    PageHeader,
    Readmore,
  },
  data() {
    const gaugeOptions = {
      chart: {
        type: "radialBar",
        offsetY: -10,
      },
      plotOptions: {
        radialBar: {
          hollow: { margin: 0 },
          startAngle: -135,
          endAngle: 135,
          dataLabels: {
            name: {
              fontSize: "12px",
              color: undefined,
              offsetY: 60,
            },
            value: {
              offsetY: 0,
              fontSize: "16px",
              color: undefined,
              formatter: function (val) {
                return val;
              },
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          shadeIntensity: 0.15,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [0, 50, 65, 91],
        },
      },
      stroke: {
        dashArray: 4,
      },
      labels: ["Score"],
    };

    return {
      urlImage: process.env.VUE_APP_BASE_API_URL_AVATAR,
      id_report: "",
      id_user: this.$store.state.authBackend.id,
      role: this.$store.state.authBackend.role,
      gaugeOptions: gaugeOptions,
      title: this.$t("malware.details-report"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Report Analysis",
          href: "/malware/report-analysis",
        },
        {
          text: this.$t("malware.details-report"),
          active: true,
        },
      ],
      center: { lat: -2.687944013464189, lng: 117.81568343337175 },
      zoom: 5,
      poi: false,
      theme: localStorage.getItem("theme") ?? "light",
      role: this.$store.state.authBackend.role,
      isShow: false,
      submitted: false,
      shared: false,
      malware: [],
      detail: "",
      info_cp: [],
      tags: [],
      comments: [],
      form: {
        validation: {
          status_report: "",
          verif_note: "",
        },
        share: {
          emails: [],
          message: "",
        },
        comment: "",
      },
      loading: {
        detail: false,
        sendcomment: false,
        listcomment: false,
        sharereport: false,
        validation: false,
      },
    };
  },
  validations: {
    form: {
      validation: {
        status_report: { required },
      },
    },
  },
  methods: {
    openValidationModal() {
      this.$bvModal.show("modal-validation");
    },
    closeValidationModal() {
      this.$bvModal.hide("modal-validation");
    },
    openShareModal() {
      this.$bvModal.show("modal-share");
    },
    closeShareModal() {
      this.$bvModal.hide("modal-share");
    },
    showMap() {
      this.isShow = this.isShow ? false : true;
    },
    mapTheme() {
      let darkMode = {
        styles: [
          { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
          {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#242f3e" }],
          },
          { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#d59563" }],
          },
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.business",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "road",
            elementType: "geometry",
            stylers: [{ color: "#38414e" }],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#212a37" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9ca5b3" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#746855" }],
          },
          {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{ color: "#1f2835" }],
          },
          {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{ color: "#f3d19c" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers: this.poi == true ? [] : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ color: "#d59563" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#17263c" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#515c6d" }],
          },
          {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#17263c" }],
          },
        ],
      };

      let lightMode = {
        styles: [
          {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "geometry",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit",
            elementType: "labels.icon",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
          {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers:
              this.poi == true
                ? [{ visibility: "on" }]
                : [{ visibility: "off" }],
          },
        ],
      };

      if (this.theme != "dark") {
        return lightMode;
      } else {
        return darkMode;
      }
    },
    setId() {
      const id = this.$route.query.id;
      if (id) {
        this.id_report = Buffer.from(id, "base64").toString("ascii");
      }
    },
    confirmRemoveReport() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: this.$t("button.cancel"),
        confirmButtonText: this.$t("button.deleted"),
      }).then((result) => {
        if (result.value) {
          this.removeReport();
        }
      });
    },
    removeReport() {
      if (this.id_report) {
        let ferr = 0;
        const idReport = Buffer.from(this.id_report).toString("base64");
        ReportService.delete(idReport)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.removeReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              Vue.swal({
                position: "top-end",
                icon: "success",
                title: "Success Remove Report",
                showConfirmButton: false,
                timer: 1500,
              });
              this.$router.push("/malware/report-analysis");
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.removeReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },
    downloadReport() {
      if (this.id_report) {
        let ferr = 0;
        const idReport = Buffer.from(this.id_report).toString("base64");
        ReportService.download(idReport)
          .then((res) => {
            if (res.status == 201) {
              res.data.text().then((tx) => {
                let new_token = JSON.parse(tx).refresh_access_token;
                userService.splitToken(new_token);
              });
              this.downloadReport();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              const fileURL = window.URL.createObjectURL(new Blob([res.data]));
              const fileLink = document.createElement("a");

              fileLink.href = fileURL;
              fileLink.setAttribute("download", "report_download.pdf");
              document.body.appendChild(fileLink);

              fileLink.click();
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.downloadReport();
            } else {
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },
    sendShareReport(e) {
      this.shared = true;

      if (this.form.share.emails.length == 0) {
        e.preventDefault();
      } else {
        this.loading.sharereport = true;
        this.shareReport();
        e.preventDefault();
      }
    },
    shareReport() {
      let ferr = 0;
      const shareData = {
        id_report: this.id_report,
        email: this.form.share.emails,
        message: this.form.share.message,
      };
      ReportService.share(shareData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.shareReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.form.share.emails = [];
            this.form.share.message = "";
            this.closeShareModal();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Success Share Report",
              showConfirmButton: false,
              timer: 1500,
            });
            this.loading.sharereport = false;
            this.shared = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.shareReport();
          } else {
            this.closeShareModal();
            this.loading.sharereport = false;
            this.shared = false;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    detailReport() {
      let ferr = 0;
      this.loading.detail = true;
      ReportService.detail(this.id_report)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.detailReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.loading.detail = false;
            this.detail = {
              id_report: res.data.data.id_report,
              title: res.data.data.title,
              description: res.data.data.description,
              status_report: res.data.data.status_report,
              risk_score: res.data.data.risk_score,
              note: res.data.data.note,
              malware_logo: res.data.data.malware_logo ?? "cyber-attack.png",
              updated_at: moment(res.data.data.updated_at).format(
                "MM/DD/YYYY hh:mm:ss"
              ),
              created_at: moment(res.data.data.created_at).format(
                "MM/DD/YYYY hh:mm:ss"
              ),
              comments: res.data.data.comments,
              comments_count: res.data.data.comments_count,
              report_by: res.data.data.report_by ?? null,
              verify_by: res.data.data.verif_by ?? null,
            };
            if (res.data.data.status_report == "2") {
              this.form.validation.status_report = "not_valid";
            }
            if (res.data.data.status_report == "3") {
              this.form.validation.status_report = "valid";
            }
            this.form.validation.verif_note = res.data.data.verif_note;
            this.malware = JSON.parse(res.data.data.malware_data);
            let infocp = this.malware.some((el) => {
              return el.sandbox_source == 1;
            });
            let cp = this.malware.find((el) => {
              return el.sandbox_source == 1;
            });
            if (infocp) {
              this.getDetailInfoCp(cp.id);
            }
            console.log(",malware ", this.malware);
            console.log("ck a =>  ", cp);
            this.tags = JSON.parse(res.data.data.tags);
            this.comments = res.data.data.comments;
          }
        })
        .catch((err) => {
          this.loading.detail = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.detailReport();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    getDetailInfoCp(md5) {
      const bodyData = {
        md5: md5,
      };
      MalwareServices.cpDetail(bodyData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.getDetailInfoCp();
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            this.info_cp = res.data.data;
            console.log("info cp ", this.info_cp);
          }
        })
        .catch((err) => {
          this.loading.detail = false;
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.getDetailInfoCp();
          } else {
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    sendComment() {
      let ferr = 0;
      const comment = {
        id_report: this.id_report,
        comment: this.form.comment,
      };
      if (this.form.comment != "") {
        this.loading.sendcomment = true;
        CommentService.send(comment)
          .then((res) => {
            if (res.status == 201) {
              let new_token = res.data.refresh_access_token;
              userService.splitToken(new_token);
              this.sendComment();
              ferr = 1;
              this.$store.dispatch("notification/refreshtoken", "refresh");
            } else {
              ferr = 2;
              this.listComment();
              const user = {
                user: {
                  ...JSON.parse(localStorage.getItem("user")),
                  ...{ id_user: this.id_user },
                },
              };
              this.comments.push({ ...user, ...res.data.data });
              this.form.comment = "";
              this.loading.sendcomment = false;
            }
          })
          .catch((err) => {
            if (err.response == undefined) {
              console.log("err ->> ", err);
            } else if (
              this.$store.state.notification.type === "refresh-token" &&
              err.response.status == 401
            ) {
              this.sendComment();
            } else {
              this.loading.sendcomment = false;
              if (err.response.status == 401) {
                userService.logout();
              } else {
                console.log("err ->> ", err);
              }
            }
          });
      }
    },
    listComment() {
      let ferr = 0;
      this.loading.listcomment = true;
      CommentService.list(this.detail.id_report)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.listComment();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.comments = res.data.data;
            this.loading.listcomment = false;
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.listComment();
          } else {
            this.loading.listcomment = false;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    giveValidation(e) {
      this.submitted = true;
      this.$v.form.validation.$touch();

      if (
        this.form.validation.status_report == "" ||
        this.form.validation.verif_note == ""
      ) {
        e.preventDefault();
      } else {
        this.validationReport();
      }
    },
    validationReport() {
      let ferr = 0;
      const validData = {
        id_report: this.id_report,
        status_report:
          this.form.validation.status_report == "valid" ? "3" : "2",
        verif_note: this.form.validation.verif_note,
      };
      this.loading.validation = true;
      ReportService.validation(validData)
        .then((res) => {
          if (res.status == 201) {
            let new_token = res.data.refresh_access_token;
            userService.splitToken(new_token);
            this.validationReport();
            ferr = 1;
            this.$store.dispatch("notification/refreshtoken", "refresh");
          } else {
            ferr = 2;
            this.loading.validation = false;
            this.detailReport();
            this.closeValidationModal();
            Vue.swal({
              position: "top-end",
              icon: "success",
              title: "Success Create Report",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        })
        .catch((err) => {
          if (err.response == undefined) {
            this.loading.validation = false;
            console.log("err ->> ", err);
          } else if (
            this.$store.state.notification.type === "refresh-token" &&
            err.response.status == 401
          ) {
            this.validationReport();
          } else {
            this.loading.validation = false;
            this.closeValidationModal();
            this.loading.listcomment = false;
            if (err.response.status == 401) {
              userService.logout();
            } else {
              console.log("err ->> ", err);
            }
          }
        });
    },
    formatByte(val) {
      return Helpers.formatBytes(val);
    },
    formatDetectTime(val) {
      return moment(val).utcOffset("+14:00").format("YYYY-MM-DD HH:mm:ss");
    },
    commentTime(create_time) {
      const currTime = moment(new Date());
      const lastTime = moment(create_time);
      const diffTime = moment.duration(currTime.diff(lastTime));
      if (diffTime._data.days != 0) {
        const days = diffTime._data.days;
        if (days < 7) {
          return diffTime._data.days + " days ago";
        } else if (days > 7) {
          return "1 week ago";
        } else if (days > 14) {
          return "2 week ago";
        } else if (days > 21) {
          return "3 week ago";
        } else {
          return moment(create_time).format("DD/MM/YYYY HH:mm:ss");
        }
      }
      if (diffTime._data.hours != 0) {
        return (
          diffTime._data.hours + " hours " + diffTime._data.minutes + " minutes"
        );
      }
      if (diffTime._data.hours == 0 && diffTime._data.minutes != 0) {
        return (
          diffTime._data.minutes +
          " minutes " +
          diffTime._data.seconds +
          " seconds"
        );
      }
      if (diffTime._data.minutes == 0 && diffTime._data.seconds != 0) {
        return diffTime._data.seconds + " seconds";
      }
    },
    getId(id) {
      return Buffer.from(id).toString("base64");
    },
  },
  created() {
    this.setId();
  },
  mounted() {
    this.detailReport();
  },
};
</script>
